var map = {
	"./Back.png": 437,
	"./Banner/1.png": 438,
	"./Banner/2.png": 439,
	"./Banner/3.png": 440,
	"./Bot": 147,
	"./Bot/": 147,
	"./Bot/index": 147,
	"./Bot/index.tsx": 147,
	"./Card1.png": 441,
	"./Card2.png": 442,
	"./Card3.png": 443,
	"./FF_Stylist_logo.png": 444,
	"./GenericImage.png": 329,
	"./Group 4385.svg": 445,
	"./Shopify-image.png": 446,
	"./add-quantity.svg": 447,
	"./adoramabg.png": 448,
	"./apm.png": 449,
	"./attachment.png": 330,
	"./background.PNG": 450,
	"./bot.svg": 451,
	"./botIcon1.png": 452,
	"./circleslider.png": 453,
	"./citiheader.png": 454,
	"./citiwelcome.png": 455,
	"./close_icon.svg": 456,
	"./close_icon_home.svg": 457,
	"./flow.PNG": 458,
	"./flyfish.png": 459,
	"./gradient.png": 331,
	"./hangers.png": 278,
	"./headerAdorama.png": 460,
	"./headergradient.png": 461,
	"./heroimagecontainer.png": 462,
	"./heroimagemob.png": 463,
	"./icons": 75,
	"./icons/": 75,
	"./icons/EmojiIcons/emoji_1.svg": 332,
	"./icons/EmojiIcons/emoji_1_color.svg": 266,
	"./icons/EmojiIcons/emoji_2.svg": 333,
	"./icons/EmojiIcons/emoji_2_color.svg": 267,
	"./icons/EmojiIcons/emoji_3.svg": 334,
	"./icons/EmojiIcons/emoji_3_color.svg": 268,
	"./icons/EmojiIcons/emoji_4.svg": 335,
	"./icons/EmojiIcons/emoji_4_color.svg": 269,
	"./icons/EmojiIcons/emoji_5.svg": 336,
	"./icons/EmojiIcons/emoji_5_color.svg": 270,
	"./icons/agent_head.svg": 464,
	"./icons/arrow-back.svg": 337,
	"./icons/arrow-down.svg": 465,
	"./icons/arrow-up.png": 466,
	"./icons/arrowright.svg": 467,
	"./icons/back-gray.svg": 468,
	"./icons/check_circle.svg": 279,
	"./icons/check_white.svg": 469,
	"./icons/checkbox-selected.svg": 470,
	"./icons/checkbox-unselected.svg": 471,
	"./icons/close-popup.svg": 472,
	"./icons/close.svg": 473,
	"./icons/cloud_error.svg": 280,
	"./icons/cloud_upload.svg": 281,
	"./icons/copy.svg": 474,
	"./icons/cross.svg": 475,
	"./icons/elipsis.png": 476,
	"./icons/expand.svg": 477,
	"./icons/feed-info.svg": 478,
	"./icons/feed-thanks.svg": 479,
	"./icons/file-type.svg": 282,
	"./icons/headerIcons/Loader Round.svg": 480,
	"./icons/headerIcons/accordian.svg": 481,
	"./icons/headerIcons/arrowLeft.svg": 482,
	"./icons/headerIcons/arrowRight.svg": 483,
	"./icons/headerIcons/back.svg": 484,
	"./icons/headerIcons/checkedRadio.svg": 485,
	"./icons/headerIcons/close.svg": 486,
	"./icons/headerIcons/diagnostics.svg": 487,
	"./icons/headerIcons/ellipses.svg": 488,
	"./icons/headerIcons/error.svg": 489,
	"./icons/headerIcons/info.svg": 490,
	"./icons/headerIcons/language.svg": 491,
	"./icons/headerIcons/logout.svg": 492,
	"./icons/headerIcons/maximise.svg": 493,
	"./icons/headerIcons/minimise.svg": 494,
	"./icons/headerIcons/notification-full.svg": 495,
	"./icons/headerIcons/notification.svg": 496,
	"./icons/headerIcons/refresh.svg": 497,
	"./icons/headerIcons/share.svg": 498,
	"./icons/headerIcons/uncheckedRadio.svg": 499,
	"./icons/headerIcons/wifiOff.svg": 500,
	"./icons/index": 75,
	"./icons/index.tsx": 75,
	"./icons/lang-info.svg": 501,
	"./icons/lock.svg": 502,
	"./icons/lock_black.svg": 503,
	"./icons/logout.svg": 504,
	"./icons/mic-filled.svg": 505,
	"./icons/mic-infinity.gif": 506,
	"./icons/mic.svg": 507,
	"./icons/multi.svg": 508,
	"./icons/no-image.png": 509,
	"./icons/offers.svg": 510,
	"./icons/pencil.svg": 511,
	"./icons/pointer_2.svg": 512,
	"./icons/ratingButtons/happy-filled.svg": 513,
	"./icons/ratingButtons/happy-outline.svg": 514,
	"./icons/ratingButtons/neutral-filled.svg": 515,
	"./icons/ratingButtons/neutral-outline.svg": 516,
	"./icons/ratingButtons/sad-filled.svg": 517,
	"./icons/ratingButtons/sad-outline.svg": 518,
	"./icons/ratingButtons/star-filled.svg": 519,
	"./icons/ratingButtons/star-outline.svg": 520,
	"./icons/ratingButtons/super-happy-filled.svg": 521,
	"./icons/ratingButtons/super-happy-outline.svg": 522,
	"./icons/ratingButtons/super-sad-filled.svg": 523,
	"./icons/ratingButtons/super-sad-outline.svg": 524,
	"./icons/ratingButtons/thumb-down-filled.svg": 525,
	"./icons/ratingButtons/thumb-up-filled.svg": 526,
	"./icons/ratingButtons/thumbs-down-outline.svg": 527,
	"./icons/ratingButtons/thumbs-up-outline.svg": 528,
	"./icons/search.svg": 529,
	"./icons/send.svg": 530,
	"./icons/share.svg": 531,
	"./icons/star_small_empty.svg": 532,
	"./icons/star_small_filled.svg": 533,
	"./icons/stop.svg": 534,
	"./icons/thinking.gif": 535,
	"./icons/thumbs-up-old.svg": 536,
	"./icons/thumbs-up.svg": 537,
	"./icons/title_down_arrow.svg": 538,
	"./icons/waiting.gif": 539,
	"./icons/waiting.svg": 540,
	"./icons/warning-red.svg": 541,
	"./icons/warning.svg": 204,
	"./kalaido.png": 283,
	"./kalaidoai.png": 542,
	"./listening.gif": 543,
	"./logo.png": 544,
	"./logo.svg": 545,
	"./marshall.png": 284,
	"./marshallai.png": 546,
	"./menu.svg": 547,
	"./message-delivery-icon.svg": 548,
	"./no-shoes-found.webp": 549,
	"./quantity-error.svg": 550,
	"./refresh.png": 551,
	"./remove-quantity.svg": 552,
	"./shopify-bot.png": 134,
	"./smile.png": 338,
	"./temp1.png": 553,
	"./temp2.png": 554,
	"./temp3.png": 555,
	"./tick-white.png": 556,
	"./upload-image-seach.webp": 557,
	"./upload-image.webp": 558,
	"./vaidya.png": 285,
	"./vaidyaai.png": 559,
	"./welcome/1.png": 560,
	"./welcome/2.png": 561,
	"./welcome/3.png": 562,
	"./welcomeScreen/Theme1/1.svg": 563,
	"./welcomeScreen/Theme1/2.svg": 564,
	"./welcomeScreen/Theme1/3.svg": 565,
	"./welcomeScreen/Theme1/4.svg": 566,
	"./welcomeScreen/Theme1/cart-selected.png": 567,
	"./welcomeScreen/Theme1/cart.png": 568,
	"./welcomeScreen/Theme1/chats-selected.png": 569,
	"./welcomeScreen/Theme1/chats.png": 570,
	"./welcomeScreen/Theme1/help-selected.png": 571,
	"./welcomeScreen/Theme1/help.png": 572,
	"./welcomeScreen/Theme1/home-selected.png": 573,
	"./welcomeScreen/Theme1/home.png": 574,
	"./welcomeScreen/Theme2/1.svg": 575,
	"./welcomeScreen/Theme2/2.svg": 576,
	"./welcomeScreen/Theme2/3.svg": 577,
	"./welcomeScreen/Theme2/4.svg": 578,
	"./welcomeScreen/Theme2/5.svg": 579,
	"./welcomeScreen/Theme2/6.svg": 580,
	"./welcomeScreen/Theme3/1.svg": 581,
	"./welcomeScreen/Theme3/2.svg": 582,
	"./whatsapp_bg.png": 583,
	"./youtube.png": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;